import type { ReactNode } from "react";
import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import formatChipsContent from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsPriceFilter/utils/formatChipsContent";
import type FindAppsPriceFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/PriceFilter/PriceFilter";

const AppsPriceFilterResult = ({ value, onFilterUpdate }: IFilterViewBaseProps<FindAppsPriceFilter>): ReactNode => {
    const text: string = useMemo((): string => {
        if (!value) {
            return "";
        }

        return formatChipsContent(value);
    }, [value]);

    if (!value || !value?.type) {
        return null;
    }

    return (
        <Flex>
            <FiltersChip
                text={text}
                onClose={() => onFilterUpdate()}
            />
        </Flex>
    );
};

export default AppsPriceFilterResult;
